import { NgModule } from '@angular/core';
import { SportsDashboardComponent } from './sports-dashboard/sports-dashboard';
import { BaselineSharedModule } from 'baseline-lib';
import { IonicPageModule } from 'ionic-angular';
import { SportsDetailPageModule } from './sports-detail/sports-detail.module';
import { SharedModule } from '../shared/shared.module';
import { SportsMenuPageModule } from './sports-menu-page/sports-menu-page.module';
import { SportsBetslipPageModule } from './sports-betslip/sports-betslip.module';
import { SportsFullDetailPageModule } from './sports-full-detail/sports-full-detail.module';
import { SportsHomeComponent } from './sports-home/sports-home';
import { FastCodesPageModule } from './fast-codes/fast-codes.module';
import { JackpotComponent } from './jackpot/jackpot';
import { JackpotDetailPageModule } from './jackpot-detail/jackpot-detail.module';


@NgModule({  
  declarations: [
    SportsHomeComponent,
    JackpotComponent,
  ],
  imports: [
    BaselineSharedModule,
    SportsDetailPageModule,
    SportsMenuPageModule,
    SportsBetslipPageModule,
    SharedModule,
    FastCodesPageModule,
    BaselineSharedModule,
    SportsFullDetailPageModule,
    JackpotDetailPageModule,
    IonicPageModule.forChild(SportsModule),
  ],
  exports:[
    SportsMenuPageModule,
    SportsHomeComponent,
    JackpotComponent,
  ]
})
export class SportsModule { }



// WEBPACK FOOTER //
// ./src/app/sports/sports.module.ts